module.exports = __webpack_public_path__ + "img/dep_petfoodandcare@3x.e7ddc7f3.png";